import React, { useEffect, useRef, useState } from "react";
import {
  FloatButton as AntdFloatButton,
  FloatButtonProps,
  FloatButtonGroupProps,
} from "antd";

interface EnhancedFloatButtonProps extends FloatButtonProps {
  Group?: React.ComponentType<FloatButtonGroupProps>; // Update this line
  children?: React.ReactNode;
}

interface EnhancedFloatButton extends React.FC<EnhancedFloatButtonProps> {
  Group: React.ComponentType<EnhancedFloatButtonProps>;
}
const withFloatingPosition = (
  WrappedComponent: React.ComponentType<EnhancedFloatButtonProps>
) => {
  const ComponentWithFloatingPosition: React.FC<EnhancedFloatButtonProps> = (
    props
  ) => {
    const { children, ...restProps } = props;
    const [isSticky, setIsSticky] = useState(false);

    const currentNode = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      if (currentNode.current) {
        const computedStyle = window.getComputedStyle(
          currentNode.current.parentElement as Element
        );

        if (computedStyle.position === "sticky") {
          setIsSticky(true);
        }
      }
    }, []);

    if (!isSticky)
      return (
        <div
          ref={currentNode}
          style={{
            display: "flex",
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            alignItems: "end",
            justifyContent: "flex-end",
            pointerEvents: "none",
          }}
        >
          <WrappedComponent
            style={{ position: "sticky", pointerEvents: "all" }}
            {...restProps}
          >
            {children}
          </WrappedComponent>
        </div>
      );
    return (
      <WrappedComponent
        style={{ position: "sticky", pointerEvents: "all" }}
        {...restProps}
      >
        {children}
      </WrappedComponent>
    );
  };

  return ComponentWithFloatingPosition;
};

const FloatButton = withFloatingPosition(
  AntdFloatButton
) as EnhancedFloatButton;

const FloatButtonGroupWithPosition = withFloatingPosition(
  AntdFloatButton.Group as React.ComponentType<EnhancedFloatButtonProps>
) as React.ComponentType<EnhancedFloatButtonProps>;

FloatButton.Group = FloatButtonGroupWithPosition;

export default FloatButton;
